module.exports = __webpack_public_path__ + "name=img/src/assets/story/1.jpg?526bdab6aee91ea68059e1e3d2fbb628";